import http from 'conversations-http/clients/http';
export const fetchInboxChannels = inboxId => http.get(`conversations-channels/v1/channel-instances/inbox/${inboxId}/paged?limit=1&offset=0&deletedFilter=NON_DELETED_ONLY`);